export default {
  "home.eyebrow": "The AllChinaBuy Resource Hub",
  "home.h1": "AllChinaBuy Spreadsheet: Find Products, Sellers & Buying Resources",
  "home.heroCopy": "Explore curated AllChinaBuy spreadsheet resources, product finds, trusted seller information, QC guides, shipping resources and practical buying tips — all organized in one easy-to-use hub.",
  "home.trustText": "Independent resource · Updated regularly · Built for smarter product research",

  "home.categoriesTitle": "Browse Product Categories",
  "home.categoriesSubtitle": "Jump straight to the category you need. Each link opens the main website with curated products.",
  "home.dropdownLabel": "Choose a category",
  "home.dropdownPlaceholder": "Select a category…",

  "home.valueTitle": "Everything You Need to Research AllChinaBuy Products",
  "home.valueSubtitle": "Six focused areas to move you from browsing to confident buying.",
  "home.value1Title": "Spreadsheet",
  "home.value1Desc": "Organized product and seller resources in one hub.",
  "home.value2Title": "Trusted Sellers",
  "home.value2Desc": "Research sellers and compare information before buying.",
  "home.value3Title": "QC Resources",
  "home.value3Desc": "Understand quality-control photos and warning signs.",
  "home.value4Title": "Shipping Guides",
  "home.value4Desc": "Learn about methods, costs and key considerations.",
  "home.value5Title": "Warehouse Guide",
  "home.value5Desc": "Understand storage, inspection and shipping workflows.",
  "home.value6Title": "Buying Guides",
  "home.value6Desc": "Step-by-step resources for every experience level.",

  "home.trustTitle": "Built for Better AllChinaBuy Research",
  "home.trustCopy": "Finding products is easy. Finding useful information before you buy is harder. Our goal is to organize scattered AllChinaBuy resources into clear pages, practical guides and safety information so you can research with greater confidence.",
  "home.trust1Title": "Organized",
  "home.trust1Desc": "Resources grouped by category and intent.",
  "home.trust2Title": "Transparent",
  "home.trust2Desc": "Information verified and clearly dated where possible.",
  "home.trust3Title": "Practical",
  "home.trust3Desc": "Guides focused on the decisions you actually need to make.",

  "home.articleTitle": "From the Resource Hub",
  "home.articleSubtitle": "Read our in-depth guide to get the most out of the AllChinaBuy spreadsheet.",
  "home.articleCardTitle": "AllChinaBuy Spreadsheet: The Complete Guide",
  "home.articleExcerpt": "Learn what the spreadsheet is, how to use it step by step, how to research sellers, check QC photos and plan shipping — with practical tips and a comparison table.",
  "home.articleReadMore": "Read the full guide",
  "home.articleMeta": "Independent guide · Updated regularly",
  "home.articlesTitle": "Latest Guides & Resources",
  "home.articlesSubtitle": "Explore our in-depth pillar guides covering the spreadsheet, sellers, QC, shipping, the warehouse and more.",
  "home.readNow": "Read now",
  "home.relatedGuides": "Related guides",
  "home.articleNotFound": "Guide not found",

  "home.faqTitle": "Frequently Asked Questions",
  "home.faqSubtitle": "Quick answers to the questions we hear most often.",
  "home.faq1Q": "What is the AllChinaBuy spreadsheet?",
  "home.faq1A": "It is an organized collection of product links, category notes and buying resources that helps you research products and sellers before you buy.",
  "home.faq2Q": "Is the AllChinaBuy spreadsheet free to use?",
  "home.faq2A": "Yes. The spreadsheet and this resource hub are free to browse, and you do not need to pay anything to view the categories and links.",
  "home.faq3Q": "How do I find trusted sellers?",
  "home.faq3A": "Look for clear product photos, a consistent listing history and reviews that mention the actual item. Cross-check sellers and review QC photos before you decide.",
  "home.faq4Q": "What are QC photos?",
  "home.faq4A": "QC (quality control) photos show your actual item before it ships. They help you spot flaws, wrong colors or sizing issues before the item leaves the warehouse.",
  "home.faq5Q": "How does shipping work?",
  "home.faq5A": "International shipping is usually calculated by weight or size. Faster methods cost more, while economy lines are cheaper but slower. Plan your shipping early to understand the total cost.",
  "home.faq6Q": "Is this the official AllChinaBuy website?",
  "home.faq6A": "No. This is an independent informational resource and is not the official AllChinaBuy website. Always verify important details directly before purchasing.",

  "home.ctaTitle": "Ready to Explore More AllChinaBuy Resources?",
  "home.ctaCopy": "Start with the spreadsheet, compare your options, learn how QC and shipping work, and explore the latest buying resources.",
  "home.ctaPrimary": "Explore AllChinaBuy Spreadsheet",
  "home.ctaSecondary": "Read the Buying Guides",
};